
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => import('@/views/Auth')
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/Home')
        },
        {
            path: '/ticket_logs',
            name: 'ticket_logs',
            component: () => import('@/views/TicketLogs')
        },
        {
            path: '/vouchers',
            name: 'vouchers',
            component: () => import('@/views/Vouchers')
        }
    ]
})